import React, {useState} from 'react';
import {Carousel} from "react-responsive-carousel";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import CarouselLoader, {CarouselError, CarouselNoData} from "./CarouselLoader";
import {BANNER_TYPE, IMAGE_SIZE} from "../../../../constants/commons";
import {safeImage} from "helpers/helperFunctions";
import {RoundedCustomButton} from "components/CustomIcon";

const CustomCarousel = ({
                          bannerList,
                          retry,
                          type = BANNER_TYPE.top,
                          mobile = true,
                          showArrowButton = false,
                          showDotIndicator,
                          defaultAspectRatio,
                          className
                        }) => {

  const {loading, data = {}, init, error} = bannerList;
  const [currentSlide, setCurrentSlide] = useState(0);

  const imageList = type === BANNER_TYPE.top ? data['mobile'] : type === BANNER_TYPE.dynamic_banner ? data.data :
    type === BANNER_TYPE.brand_week || type === BANNER_TYPE.promotional_events || type === BANNER_TYPE.campaigns ? data : [];
  const aspectRatio = data?.page_info?.extras ?? defaultAspectRatio;

  return (
    error ? <CarouselError errorMsg={error} retry={retry} aspectRatio={mobile ? aspectRatio?.ar : aspectRatio?.ar_web}/>
      : loading ?
        <CarouselLoader forceMobileVersion={type !== BANNER_TYPE.top}
                        length={aspectRatio?.total_items}
                        aspectRatio={mobile ? aspectRatio?.ar : aspectRatio?.ar_web}
                        showIndicators={mobile || type === BANNER_TYPE.top}/>
        : init && (imageList?.length) ?
          <>
            <div
              className={`${className ? `${className} ` : ""}${type === BANNER_TYPE.top && !mobile ? "app-side-pd " : ""}relative`}>
              <div className={`${mobile ? "" : "app-rounded"} overflow-hidden`}>
                <Carousel showIndicators={false} showThumbs={false} showStatus={false} interval="7000" autoPlay={true}
                          infiniteLoop={true} selectedItem={currentSlide} onChange={setCurrentSlide} showArrows={false}>
                  {
                    imageList.map((item) => type === BANNER_TYPE.brand_week ?
                      <img className="image-aspect-ratio force object-cover" key={`carousel-item-week-${item.id}`}
                           src={safeImage(item.images, IMAGE_SIZE[mobile ? "1024" : "1920"])} alt={item.name}/>
                      : type === BANNER_TYPE.promotional_events ?
                        <img className="image-aspect-ratio force object-cover" key={`carousel-item-p-events-${item.id}`}
                             src={item.image} alt={item.name}/> :
                        type === BANNER_TYPE.campaigns ?
                          <img className="image-aspect-ratio force object-cover"
                               key={`carousel-item-campaigns-${item.id}`}
                               src={item.banner_url} alt={item.title}/> :
                          <img
                            style={{...(aspectRatio && {aspectRatio: `${mobile ? aspectRatio?.ar : aspectRatio?.ar_web}`})}}
                            className={`${mobile ? "image-aspect-ratio" : "image-aspect-ratio-web"} force object-cover`}
                            key={`carousel-item-top-${item.id}`}
                            src={mobile ? (item.image ?? item.image_url) : (item.image_for_web ?? item.image_url_web)}
                            alt={item.title}/>
                    )
                  }
                </Carousel>
              </div>
              {(imageList?.length > 1 && !mobile && showArrowButton) &&
                <>
                  <RoundedCustomButton size="2xl" className="right-10 absolute top-1/2 -translate-y-2/4" isLeft={false}
                                       icon="chevron_right"
                                       onClick={() => setCurrentSlide(currentSlide + 1)}/>
                  <RoundedCustomButton size="2xl" className="left-10 absolute top-1/2 -translate-y-2/4"
                                       icon="chevron_left"
                                       onClick={() => setCurrentSlide(currentSlide - 1)}/>
                </>}

            </div>
            {(mobile || type === BANNER_TYPE.top || showDotIndicator) &&
              <div className="flex justify-center space-x-1 mt-1.5 mb-1.5">
                {Array.from({length: imageList.length}, (_, i) =>
                  <div key={`loader-carousel-${i}`} onClick={() => setCurrentSlide(i)}
                       className={`${i === currentSlide ? 'gradient-primary' : 'bg-rand-200 cursor-pointer'} ${mobile ? "w-1.5 h-1.5" : "w-2 h-2"} rounded-md`}/>
                )}
              </div>
            }

          </>
          : <CarouselNoData
            msg={type === BANNER_TYPE.promotional_events ? "Data empty(This section wont be visible)" : "No data"}/>

  );
};

export default React.memo(CustomCarousel);